const groupMarketsPostFields = (fields) => {
  const introFields = fields.filter((field) => !field.key.startsWith('post-'));
  const postGroups = [];

  for (let index = 1; index <= 20; index += 1) {
    const groupFields = fields
      .filter((field) => field.key.startsWith(`post-${index}-`))
      .sort((a, b) => a.sortOrder - b.sortOrder);

    if (!groupFields.some((field) => field.key === `post-${index}-category`)) {
      break;
    }

    postGroups.push({ index, fields: groupFields });
  }

  return { introFields, postGroups };
};

export default groupMarketsPostFields;
